import * as React from 'react';
import { ReliableDeveloper as ReliableDeveloperComponent } from '../../components/ReliableDeveloper';
import { useSelector } from 'react-redux';
import { getReliableData } from '../../selectors';
import { trackClickAboutCheckingMethod } from './tracking';

export function ReliableDeveloper() {
  const reliableData = useSelector(getReliableData);

  if (!reliableData.isReliable || !reliableData.description || !reliableData.checkingMethodUrl) {
    return null;
  }

  return (
    <ReliableDeveloperComponent
      checkingUrl={reliableData.checkingMethodUrl}
      description={reliableData.description}
      onButtonClick={trackClickAboutCheckingMethod}
    />
  );
}
